// extracted by mini-css-extract-plugin
module.exports = {"sidebar-parent":"sideMenu_sidebar-parent__35DZf"};